import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InstantSalesReport/InstantSalesReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class InstantSalesReport extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InstantSalesReport/InstantSalesReport")
	}

	render() {
		return (
			<Activity 
				name="InstantSalesReport"
				RenderedComponent={this.RenderedComponent}
				context="InstantSalesReport"
				action="InstantSalesReport"
				formActions={FormAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(InstantSalesReport)
